"use client"

import { FolderOpen, Plus, Settings } from "lucide-react"
import { ProjectSummary } from "@/services/projectService"
import {
  Select,
  SelectContent,
  SelectItem,
  SelectSeparator,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select"
import { Button } from "@/components/ui/button"

type ProjectSelectorProps = {
  projects: ProjectSummary[]
  currentProjectId: string | null
  onProjectSelect: (projectId: string | null) => void
  onNewProject: () => void
  onProjectSettings: (projectId: string) => void
}

export function ProjectSelector({
  projects,
  currentProjectId,
  onProjectSelect,
  onNewProject,
  onProjectSettings,
}: ProjectSelectorProps) {
  return (
    <div className="flex items-center gap-1">
      <div className="flex-1 min-w-0">
        <Select
          value={currentProjectId || "__all__"}
          onValueChange={(value) => {
            if (value === "__all__") {
              onProjectSelect(null)
            } else {
              onProjectSelect(value)
            }
          }}
        >
          <SelectTrigger className="w-full text-sm h-8" size="sm">
            <FolderOpen className="h-3.5 w-3.5 shrink-0" />
            <span className="truncate">
              <SelectValue placeholder="すべてのプロジェクト" />
            </span>
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="__all__">すべてのプロジェクト</SelectItem>
            <SelectItem value="__unassigned__">一般（プロジェクトなし）</SelectItem>
            {projects.length > 0 && <SelectSeparator />}
            {projects.map((project) => (
              <SelectItem key={project.projectId} value={project.projectId}>
                {project.name}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
      {currentProjectId && currentProjectId !== "__unassigned__" && (
        <Button
          variant="ghost"
          size="icon"
          className="h-7 w-7 shrink-0"
          onClick={() => onProjectSettings(currentProjectId)}
          title="プロジェクト設定"
        >
          <Settings className="h-3.5 w-3.5" />
        </Button>
      )}
      <Button
        variant="ghost"
        size="icon"
        className="h-7 w-7 shrink-0"
        onClick={onNewProject}
        title="新しいプロジェクト"
      >
        <Plus className="h-3.5 w-3.5" />
      </Button>
    </div>
  )
}
